import React from 'react';

import { type DataTableSortProps } from '../../DataTable.types';

import { IconWrapper, Label, StyledSortAction } from './SortAction.style';

export interface SortActionProps<T> extends DataTableSortProps<T> {
    label: string;
    ariaLabel?: string;
}

export function SortAction<T>({
    label,
    ariaLabel,
    disabled = false,
    columnId,
    sortDirection,
    onSort,
}: SortActionProps<T>) {
    function handleSort() {
        const nextDirection = sortDirection === 'descending' ? 'ascending' : 'descending';
        onSort(columnId, nextDirection);
    }

    return (
        <StyledSortAction
            $direction={sortDirection}
            ariaLabel={ariaLabel}
            disabled={disabled}
            pressed={sortDirection ? true : undefined}
            onAction={handleSort}
        >
            <Label>{label}</Label>

            <IconWrapper>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="m10.002 0 6.402 6.402-1.586 1.587-4.816-4.816-4.816 4.816L3.6 6.402 10.002 0Z" />
                    <path d="m10.002 16.827 4.816-4.816 1.586 1.587L10.002 20 3.6 13.598l1.586-1.587 4.816 4.816Z" />
                </svg>
            </IconWrapper>
        </StyledSortAction>
    );
}

SortAction.Label = Label;
